export default class NodeEnvironmentTypes {
  static PRODUCTION = "production";

  static DEVELOPMENT = "development";
}
